import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/constants/queryKeys';
import { churchesService } from '@/services/churches.service';

export const useChurch = (id: string | undefined) => {
  return useQuery({
    queryKey: [QUERY_KEYS.CHURCH, id],
    queryFn: () => churchesService.getChurch(id ?? ''),
    enabled: !!id,
  });
};
